import React, { useState, useEffect } from "react";

//import "./index.less";

import { IItemData } from "./common.typing";
import PageTitle from "./PageTitle";
import CommonList from "./CommonList";
import AlphabetContactList from "./AlphabetContactList";

export interface PartnerMemberProps {
    prePage: string;
    type?: string;
    onChangeCurPage: (page: string) => void;
    currentList: IItemData[];
    setCurrentList: (list: IItemData[]) => void;
    showExternalContact?: boolean;
    getPartnerMemberList?: (
        id: number | string,
        show_external: number
    ) => Promise<any>;
    currentPartnerInfo: {
        id: number | string;
        name: string;
    };
    /** 不可用 id，包括 group、user、session、org */
    disabledids?: string[];
    requiredList?: IItemData[];
    multiple?: boolean;
    getPartnerMemberGrouped?:(
        id: number | string,
        show_external: number
    ) => Promise<any>
}

const PartnerMember: React.FC<PartnerMemberProps> = ({
    prePage,
    onChangeCurPage,
    currentList,
    setCurrentList,
    getPartnerMemberList,
    getPartnerMemberGrouped,
    currentPartnerInfo,
    disabledids,
    requiredList,
    showExternalContact,
    multiple,
}) => {
    const [partnerMemberList, setPartnerMemberList] = useState([]);
    let show_external = showExternalContact ? 1 : 0;
    useEffect(() => {
        console.log("useEffect");
        loadPartnerMemberList();
    }, []);

    const loadPartnerMemberList = async () => {
        console.log("loadPartnerMemberList");
        if (getPartnerMemberGrouped) {
            const result = await getPartnerMemberGrouped(
                currentPartnerInfo.id,
                show_external
            );
            setPartnerMemberList(result);
        }
        // else{
        // if (!getPartnerMemberList) {
        //     console.error("getPartnerMemberList is not available");
        //     return;
        // }
        // const result = await getPartnerMemberList(
        //     currentPartnerInfo.id,
        //         show_external
        //     );
        //     setPartnerMemberList(result);
        // }
    };

    /**
     * pageTitle 返回
     * prePage: home
     */
    const onBack = () => {
        onChangeCurPage(prePage);
    };
        // 有 A-Z 分组数据时使用分组展示
    if (getPartnerMemberGrouped) {
        return (
            <div className="myGroup">
                <PageTitle
                    {...{
                        title: currentPartnerInfo.name,
                        onBack,
                    }}
                />
                <div className="myGroup alphabetView">
                    <AlphabetContactList
                        groupedData={partnerMemberList}
                        disabledids={disabledids}
                        currentList={currentList}
                        setCurrentList={setCurrentList}
                        requiredList={requiredList}
                        multiple={multiple}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="myGroup">
            <PageTitle
                {...{
                    title: currentPartnerInfo.name,
                    onBack,
                }}
            />
            <CommonList
                {...{
                    type: "member",
                    isShowOrg: true,
                    showCheckAll: true,
                    list: partnerMemberList,
                    currentList,
                    setCurrentList,
                    disabledids,
                    requiredList,
                    multiple,
                }}
            />
        </div>
    );
};

export default PartnerMember;
